import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FlagComponent } from '../flag/flag.component';
import { IconsModule } from '../icons/icons.module';
import { ButtonComponent } from './button.component';

const exportedDeclarations = [ButtonComponent];

@NgModule({
  imports: [CommonModule, IconsModule, FlagComponent],
  declarations: exportedDeclarations,
  exports: exportedDeclarations,
})
export class ButtonModule {}
